export type ProductRequestCategory =
	| 'fertilizer'
	| 'lime'
	| 'conditioner'
	| 'organic'
	| 'special'
	| 'defensive';

export type ProductRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export type ProductRequestsTab = 'pending' | 'approved' | 'rejected' | 'all';

export interface ProductRequest {
	_id: string;
	name: string;
	manufacturer: string;
	category: ProductRequestCategory;
	note?: string;
	status: ProductRequestStatus;
	reason?: string;
	userId: string;
	userName: string;
	createdAt: Date;
	updatedAt: Date;
}

export const CATEGORY_LABELS: Record<ProductRequestCategory, string> = {
	fertilizer: 'Fertilizante',
	lime: 'Corretivo',
	conditioner: 'Condicionador',
	organic: 'Organomineral',
	special: 'Especial / Bioestimulante',
	defensive: 'Defensivo',
};

export const STATUS_LABELS: Record<ProductRequestStatus, string> = {
	PENDING: 'Pendente',
	APPROVED: 'Aprovado',
	REJECTED: 'Rejeitado',
};
